
import Login from "../../components/login";


export default function LoginLayout() {
    return (
        <div >
            <Login />
        </div>
    )
}